import './transport-type.scss';

import { Outlet } from "react-router-dom";

import { FilterTransportTypeProvider } from "./filter-transport-type/filter-transport-type.context";

export function TransportType() {
  return (
    <div id="ShellTransportType" className="transport-type">
       <FilterTransportTypeProvider>
        <Outlet />
      </FilterTransportTypeProvider>
    </div>
  );
}

export default TransportType;
